export const DAILY_WORKING_HOURS = 8.5;
export const MAX_WORKING_DAYS_PER_WEEK = 5;

export const MAX_WEEKLY_WORKING_HOURS = DAILY_WORKING_HOURS * MAX_WORKING_DAYS_PER_WEEK;

export const MAX_WEEKLY_WORKING_MINUTES = MAX_WEEKLY_WORKING_HOURS * 60;

export const EMPLOYEE_SCHEDULE_FIELDS = {
  EMPLOYEE_ID: 'employeeId',
  ISO_WEEK: 'isoWeek',
  AVAILABILITY_MINUTES: 'availabilityMinutes',
};

export const API_DEPARTMENT_KEYS = {
  drawing: 'DRAWING',
  design: 'DESIGN',
  'site visit': 'SITE_VISIT',
};

export const DEPARTMENTS = {
  DRAWING: 'DRAWING',
  DESIGN: 'DESIGN',
  SITE_VISIT: 'SITE_VISIT',
};

export const DEPARTMENT_LABELS = {
  [DEPARTMENTS.DRAWING]: 'Drawing',
  [DEPARTMENTS.DESIGN]: 'Design',
  [DEPARTMENTS.SITE_VISIT]: 'Site Visit',
};
